import React from 'react';

/* eslint-disable */
const Thumbnails = (props) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24">
    <g fillRule="evenodd">
      <rect width="6" height="6"/>
      <rect width="6" height="6" y="9"/>
      <rect width="6" height="6" y="18"/>
      <rect width="6" height="6" x="9"/>
      <rect width="6" height="6" x="9" y="9"/>
      <rect width="6" height="6" x="9" y="18"/>
      <rect width="6" height="6" x="18"/>
      <rect width="6" height="6" x="18" y="9"/>
      <rect width="6" height="6" x="18" y="18"/>
    </g>
  </svg>
);
/* eslint-enable */

export default Thumbnails;
